import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    formatDateAndTime: ({ returnBothDateAndTime, date }: {
        returnBothDateAndTime: boolean;
        date: Date;
    }) => string;
    formatTimeOnly: (date: Date) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Formats the date with month, day, year, and then includes the time if returnBothDateAndTime is true (i.e. Nov 25, 2020 at 7:50 PM or just Nov 25, 2020) */
            formatDateAndTime: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ returnBothDateAndTime, date }: {
                        returnBothDateAndTime: boolean;
                        date: Date;
                    }): string => { return __intl__.intl().formatMessage({ id: "GetFormattedDate.formatDateAndTime.0?c=1k7u5alwlta97", defaultMessage: "{date, date, medium}{returnBothDateAndTime, select, true { at {date, time, short}} other {}}" }, { date: date, returnBothDateAndTime: returnBothDateAndTime }); });
                },
                enumerable: true,
                configurable: true
            },
            /** Formats the time only with the short format (i.e. 7:50 PM) */
            formatTimeOnly: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (date: Date): string => { return __intl__.intl().formatMessage({ id: "GetFormattedDate.formatTimeOnly.0?c=20ri13d62r6cv", defaultMessage: "{date, time, short}" }, { date: date }); });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
